import styled, { css } from 'styled-components/macro'
import { theme } from 'styled-tools'

const primaryStyles = css`
  border: 2px solid transparent;
  background-color: ${theme('pink')};
  color: ${theme('white')};

  &:hover,
  &:focus {
    background-color: ${theme('darkPink')};
    border-color: ${theme('darkPink')};
    color: ${theme('white')};
    text-decoration: none;
  }
`

const secondaryStyles = css`
  border: 2px solid ${theme('black')};
  background-color: transparent;
  color: ${theme('black')};

  &:hover,
  &:focus {
    background-color: transparent;
    color: ${theme('black')};
    text-decoration: underline;
  }
`

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0.85rem 1.75rem;
  border-radius: 0;
  font: inherit;
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  appearance: none;
  transition: background-color 0.2s ease, color 0.2s ease;

  ${props => (props.$variant === 'secondary' ? secondaryStyles : primaryStyles)};
`

export { StyledButton }
